module.exports = __webpack_public_path__ + "img/error.44688842.svg";